import * as url from "../../foundation/utils/url";

function checkRequired(value, errorMessages) {
    return value ? null : errorMessages.required;
}

function checkLength(length, value, errorMessages) {
    return value && value.length <= length ? null : errorMessages.length;
}

function checkMinLength(minLength, value, errorMessages) {
    return value && value.length < minLength ? errorMessages.minLength : null;
}

function checkSpaces(value, errorMessages) {
    return /\s/.test(value) ? errorMessages.containsSpace : null;
}

function isValidUrl(value, errorMessages) {
    return !value || url.isValidUrl(value) ? null : errorMessages.notValidURI;
}

function checkContainsOnlyWhiteSpace(value, errorMessages) {
    return value.trim() === "" ? errorMessages.containOnlyWhiteSpace : null;
}

/**
 * Inline validation for form field values
 * @param {String} name
 * @param {unknown} value
 * @param {Object} fieldValidations
 * @param {Object} errorMessages
 * @returns {String} error message
 */
function validateField(name, value, fieldValidations, errorMessages) {
    const validators = fieldValidations[name];

    if (!validators) {
        return null;
    }

    for (let validator of validators) {
        const error = validator(value, errorMessages[name]);
        if (error) {
            return error;
        }
    }

    return null;
}

/**
 * Trims all values and remove keys if their value is empty
 * @param {Object} values
 * @returns {Object} payload
 */
function preparePayload(values) {
    return Object.keys(values).reduce((payload, key) => {
        const value = values[key];
        payload[key] = value;
        if (Array.isArray(value)) {
            const arr = value.map(item => item.trim());
            payload[key] = arr;
        } else if (value && typeof value === "string") {
            payload[key] = value.trim();
        }
        return payload;
    }, {});
}

export {
    checkRequired,
    checkLength,
    checkMinLength,
    checkSpaces,
    isValidUrl,
    preparePayload,
    validateField,
    checkContainsOnlyWhiteSpace
};
